/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ConsumeInputs */

const cs_enum_consume = /** @type {(inputs: Enum_ConsumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čerpání`)
};

const en_enum_consume = /** @type {(inputs: Enum_ConsumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consume`)
};

/**
* | output |
* | --- |
* | "Consume" |
*
* @param {Enum_ConsumeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_consume = /** @type {((inputs?: Enum_ConsumeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ConsumeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_consume(inputs)
	return cs_enum_consume(inputs)
});